import { gql } from '@apollo/client';

export const AccountingQreFragment = gql`
  fragment AccountingQre on AccountingQre {
    id
    name
    qualifiedAmountCents
    amountCents
    qreRdPercentage
    accountingProvider
    state
    country
    account
    department
    costCenter
    entity
    rdCategory
    fiscalYearId
    accountingExpenseId
  }
`;
